"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.View = void 0;
exports.view = view;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const ReactRedux = __importStar(require("react-redux"));
const GraphQLRequest = __importStar(require("@genesys/graphql-request"));
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const Loaders = __importStar(require("@genesys/client-core/lib/loaders"));
const Contexts = __importStar(require("@genesys/client-core/lib/contexts"));
const export_text_issues_1 = require("../shared/export-text-issues");
const GraphQLQuery = __importStar(require("@genesys/client-core/lib/graphql-query"));
const Shared = __importStar(require("../shared/queries"));
const system_type_validation_state_1 = require("./system-type-validation-state");
const Exporter = __importStar(require("@genesys/client-core/lib/exporter"));
const Root = styled_components_1.default.div `
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
`;
const SettingsContainer = styled_components_1.default.div `
  flex: 0 0 auto;
  padding: 20px;
  h3 {
    padding: 5px 0;
  }
  ul {
    li {
      padding: 5px;
    }
  }

  button {
    margin: 20px 0;
  }
`;
const LanguageContainer = styled_components_1.default.div `
  padding: 20px;
  table {
    border: 1px solid #ddd;
    display: block;
    height: 300px;
    overflow: auto;
  }
`;
const ResultContainer = styled_components_1.default.div `
  flex: 1 0 auto;
  button {
    margin: 20px 0;
  }
  textarea {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    background: #ebebeb;
    box-sizing: border-box;
    resize: none;
  }
`;
const queryProduct = (0, graphql_tag_1.default) `
  query SystemTypeValidationProduct {
    product {
      activeSystemTypes {
        id
      }
      languages {
        id
      }
    }
  }
`;
const getSystemTypePreValidationResultQuery = (0, graphql_tag_1.default) `
  query SystemTypeValidationPreValidationResult(
    $input: SystemTypeValidationInputType!
  ) {
    product {
      getSystemTypePreValidationResult(input: $input) {
        ok
        errors
      }
    }
  }
`;
const getRangeFilterErrorsQuery = (0, graphql_tag_1.default) `
  query SystemTypeValidationRangeFilterErrors(
    $input: SystemTypeValidationInputType!
  ) {
    product {
      getSystemTypeRangeFilterErrors(input: $input)
    }
  }
`;
const getSysAndNewFilterErrorsQuery = (0, graphql_tag_1.default) `
  query SystemTypeValidationSysAndNewFilterErrors(
    $input: SystemTypeValidationInputType!
  ) {
    product {
      getSystemTypeSysAndNewFilterErrors(input: $input)
    }
  }
`;
const getTemplateErrorsQuery = (0, graphql_tag_1.default) `
  query SystemTypeValidationTemplateErrors(
    $input: SystemTypeValidationInputType!
  ) {
    product {
      getSystemTypeTemplateErrors(input: $input)
    }
  }
`;
const getEnergyErrorsQuery = (0, graphql_tag_1.default) `
  query SystemTypeValidationEnergyErrors(
    $input: SystemTypeValidationInputType!
  ) {
    product {
      getSystemTypeEnergyErrors(input: $input)
    }
  }
`;
const getValueSourceUsageErrorsQuery = (0, graphql_tag_1.default) `
  query SystemTypeValidationValueSourceUsageErrors(
    $input: SystemTypeValidationInputType!
  ) {
    product {
      getSystemTypeValueSourceUsageErrors(input: $input)
    }
  }
`;
const getCalculationMappingsErrorsQuery = (0, graphql_tag_1.default) `
  query SystemTypeValidationCalculationMappingsErrors(
    $input: SystemTypeValidationInputType!
  ) {
    product {
      getSystemTypeCalculationMappingErrors(input: $input)
    }
  }
`;
const getCircularReferencesErrorsQuery = (0, graphql_tag_1.default) `
  query SystemTypeValidationCircularReferencesErrors(
    $input: SystemTypeValidationInputType!
  ) {
    product {
      getSystemTypeCircularReferencesErrors(input: $input)
    }
  }
`;
const getCostTablesErrorsQuery = (0, graphql_tag_1.default) `
  query SystemTypeValidationCostTablesErrors(
    $input: SystemTypeValidationInputType!
  ) {
    product {
      getSystemTypeCostTablesErrors(input: $input)
    }
  }
`;
const getProductPropertyIssuesQuery = (0, graphql_tag_1.default) `
  query SystemTypeValidationProductPropertyIssues(
    $input: SystemTypeValidationInputType!
  ) {
    product {
      getSystemTypeProductPropertyIssues(input: $input)
    }
  }
`;
const getProductPropertyTextIssuesQuery = (0, graphql_tag_1.default) `
  query SystemTypeValidationProductPropertyTextIssues(
    $input: SystemTypeTextValidationInputType!
  ) {
    product {
      getSystemTypeProductPropertyTextIssues(input: $input) {
        ...ProductPropertyTextIssueFragment
      }
    }
  }

  ${Shared.ProductTextFragment}
`;
const pleaseSelect = "Please select";
function view({ state, dispatch }) {
    return (React.createElement(Contexts.clientConfigContext.Consumer, null, config => (React.createElement(GraphQLQuery.QueryProductSimple, { query: queryProduct, variables: {} }, productData => {
        const activeSystemTypes = productData.product.activeSystemTypes
            .map(ast => ast.id)
            .sort((a, b) => a.localeCompare(b));
        const availableLanguages = productData.product.languages
            .filter(l => l.id !== "xx-XX")
            .map(l => l.id)
            .sort((a, b) => a.localeCompare(b));
        return (React.createElement(Loaders.PleaseWaitOverlayLoaderIndicator, { active: state.loading },
            React.createElement(Loaders.ProgressOverlayLoaderIndicator, { active: state.validationProgress.inProgress, message: state.validationProgress.message, current: state.validationProgress.current, max: state.validationProgress.max },
                React.createElement(Root, null,
                    React.createElement(SettingsContainer, null,
                        React.createElement(Elements.ExpanderWithArrow, { isCollapsed: state.filterCollapsed, onToggle: () => {
                                dispatch(system_type_validation_state_1.Action.SystemTypeValidationToggleFilter());
                            }, text: "Filter" }),
                        !state.filterCollapsed && (React.createElement(React.Fragment, null,
                            React.createElement("h3", null, "This This tool validates all data (property filters etc) connected to a system type. Note that all tables might not be completely checked as new features are constantly added.tool validates all data (property filters etc) connected to a system type. Note that all tables might not be completely checked as new features are constantly added."),
                            React.createElement("ul", null,
                                React.createElement("li", null,
                                    React.createElement(Elements.SelectBox, { value: state.settings.systemTypeId || pleaseSelect, onChange: e => {
                                            dispatch(system_type_validation_state_1.Action.SystemTypeValidationSetSettings(Object.assign(Object.assign({}, state.settings), { systemTypeId: e.target.value, validateSysAndNewFilters: false, validateRangeFilters: false, validateValueSourceUsage: false, validateCalculationMappings: false, validateCircularReferences: false, validateProperties: false, validatePropertyTexts: false, languagesToValidate: [] })));
                                        } },
                                        React.createElement("option", null, pleaseSelect),
                                        activeSystemTypes.map(st => (React.createElement("option", { value: st }, st))))),
                                React.createElement("li", null,
                                    React.createElement("label", null,
                                        React.createElement("input", { disabled: true, type: "checkbox", checked: true }),
                                        "1. Pre-validation. (Checks if inputs are ok and if all necessary components exists)")),
                                React.createElement("li", null,
                                    React.createElement("label", null,
                                        React.createElement("input", { disabled: state.settings.systemTypeId === undefined ||
                                                state.settings.systemTypeId === pleaseSelect, type: "checkbox", checked: state.settings.validateRangeFilters, onChange: () => {
                                                dispatch(system_type_validation_state_1.Action.SystemTypeValidationSetSettings(Object.assign(Object.assign({}, state.settings), { validateRangeFilters: !state.settings.validateRangeFilters })));
                                            } }),
                                        "2. Range filters (SYS) on Placement Rules, Sequence rules, Products, Screens, Air point properties, Reports, Casing generators, Mechanical sketch providers, P&ID generators and System type validity Times.")),
                                React.createElement("li", null,
                                    React.createElement("label", null,
                                        React.createElement("input", { disabled: state.settings.systemTypeId === undefined ||
                                                state.settings.systemTypeId === pleaseSelect, type: "checkbox", checked: state.settings.validateSysAndNewFilters, onChange: () => {
                                                dispatch(system_type_validation_state_1.Action.SystemTypeValidationSetSettings(Object.assign(Object.assign({}, state.settings), { validateSysAndNewFilters: !state.settings
                                                        .validateSysAndNewFilters })));
                                            } }),
                                        "3. Validate Sys and New filters - Checks combined SYS- and NEW- filters in the templates.")),
                                React.createElement("li", null,
                                    React.createElement("label", null,
                                        React.createElement("input", { disabled: state.settings.systemTypeId === undefined ||
                                                state.settings.systemTypeId === pleaseSelect, type: "checkbox", checked: state.settings.validateTemplates, onChange: () => {
                                                dispatch(system_type_validation_state_1.Action.SystemTypeValidationSetSettings(Object.assign(Object.assign({}, state.settings), { validateTemplates: !state.settings.validateTemplates })));
                                            } }),
                                        "4. Validate Templates- A well rounded validation of the system templates.")),
                                React.createElement("li", null,
                                    React.createElement("label", null,
                                        React.createElement("input", { disabled: state.settings.systemTypeId === undefined ||
                                                state.settings.systemTypeId === pleaseSelect, type: "checkbox", checked: state.settings.validateEnergy, onChange: () => {
                                                dispatch(system_type_validation_state_1.Action.SystemTypeValidationSetSettings(Object.assign(Object.assign({}, state.settings), { validateEnergy: !state.settings.validateEnergy })));
                                            } }),
                                        "5. Energy - Validates Visibility filters only at the moment.")),
                                React.createElement("li", null,
                                    React.createElement("label", null,
                                        React.createElement("input", { disabled: state.settings.systemTypeId === undefined ||
                                                state.settings.systemTypeId === pleaseSelect, type: "checkbox", checked: state.settings.validateValueSourceUsage, onChange: () => {
                                                dispatch(system_type_validation_state_1.Action.SystemTypeValidationSetSettings(Object.assign(Object.assign({}, state.settings), { validateValueSourceUsage: !state.settings
                                                        .validateValueSourceUsage })));
                                            } }),
                                        "6. Value source usage (Tries to find malformed value source references).")),
                                React.createElement("li", null,
                                    React.createElement("label", null,
                                        React.createElement("input", { disabled: state.settings.systemTypeId === undefined ||
                                                state.settings.systemTypeId === pleaseSelect, type: "checkbox", checked: state.settings.validateCalculationMappings, onChange: () => {
                                                dispatch(system_type_validation_state_1.Action.SystemTypeValidationSetSettings(Object.assign(Object.assign({}, state.settings), { validateCalculationMappings: !state.settings
                                                        .validateCalculationMappings })));
                                            } }),
                                        "7. Calculation mapping errors (Tries to find problematic Case- and Select- input- and outputmappings).")),
                                React.createElement("li", null,
                                    React.createElement("label", null,
                                        React.createElement("input", { disabled: state.settings.systemTypeId === undefined ||
                                                state.settings.systemTypeId === pleaseSelect, type: "checkbox", checked: state.settings.validateCircularReferences, onChange: () => {
                                                dispatch(system_type_validation_state_1.Action.SystemTypeValidationSetSettings(Object.assign(Object.assign({}, state.settings), { validateCircularReferences: !state.settings
                                                        .validateCircularReferences })));
                                            } }),
                                        "8. System wide circular reference check (might take a long time depending on how big and complex the system type is).")),
                                React.createElement("li", null,
                                    React.createElement("label", null,
                                        React.createElement("input", { disabled: state.settings.systemTypeId === undefined ||
                                                state.settings.systemTypeId === pleaseSelect, type: "checkbox", checked: state.settings.validateCostTables, onChange: () => {
                                                dispatch(system_type_validation_state_1.Action.SystemTypeValidationSetSettings(Object.assign(Object.assign({}, state.settings), { validateCostTables: !state.settings.validateCostTables })));
                                            } }),
                                        "9. Cost tables validation (Checks BoM/BreakDown/Workcenter) for empty partNos and partNos with leading or trailing spaces and malformed formulas.")),
                                React.createElement("li", null,
                                    React.createElement("label", null,
                                        React.createElement("input", { disabled: state.settings.systemTypeId === undefined ||
                                                state.settings.systemTypeId === pleaseSelect, type: "checkbox", checked: state.settings.validateProperties, onChange: () => {
                                                dispatch(system_type_validation_state_1.Action.SystemTypeValidationSetSettings(Object.assign(Object.assign({}, state.settings), { validateProperties: !state.settings.validateProperties })));
                                            } }),
                                        "10. Tries to find issues with product properties on a system wide level. Trying to find out if a property is of the same type on each product, as well as comparing each products coverage of a given properties values, e.g. does DHU have less dhmodel values than SYS.")),
                                React.createElement("li", null,
                                    React.createElement("label", null,
                                        React.createElement("input", { disabled: state.settings.systemTypeId === undefined ||
                                                state.settings.systemTypeId === pleaseSelect, type: "checkbox", checked: state.settings.validatePropertyTexts, onChange: () => {
                                                let languages = [];
                                                if (!state.settings.validatePropertyTexts) {
                                                    dispatch(system_type_validation_state_1.Action.SystemTypeValidationSetShowLanguages(true));
                                                    languages = system_type_validation_state_1.defaultLanguages;
                                                }
                                                dispatch(system_type_validation_state_1.Action.SystemTypeValidationSetSettings(Object.assign(Object.assign({}, state.settings), { validatePropertyTexts: !state.settings.validatePropertyTexts, languagesToValidate: languages })));
                                            } }),
                                        "11. Tries to find issues with product property and product property value translations on a system wide level. It will also add warnings for missing/multiple and text type for [productId, propertyName]- and [productId, propertyName, propertyValue] translations.")),
                                state.settings.systemTypeId &&
                                    state.settings.systemTypeId !== pleaseSelect &&
                                    state.settings.validatePropertyTexts && (React.createElement(LanguageContainer, null,
                                    React.createElement("label", null,
                                        React.createElement("input", { disabled: state.settings.systemTypeId ===
                                                undefined ||
                                                state.settings.systemTypeId ===
                                                    pleaseSelect ||
                                                !state.settings.validatePropertyTexts, type: "checkbox", checked: state.showLangugagesList, onChange: e => {
                                                dispatch(system_type_validation_state_1.Action.SystemTypeValidationSetShowLanguages(e.target.checked));
                                            } }),
                                        "Show language selections"),
                                    state.showLangugagesList && (React.createElement(React.Fragment, null,
                                        React.createElement(React.Fragment, null,
                                            React.createElement(Elements.StandardButton, { onClick: () => {
                                                    dispatch(system_type_validation_state_1.Action.SystemTypeValidationCheckAllLanguages(availableLanguages));
                                                } }, "Check all"),
                                            React.createElement(Elements.StandardButton, { onClick: () => {
                                                    dispatch(system_type_validation_state_1.Action.SystemTypeValidationUnCheckAllLanguages());
                                                } }, "Clear all"),
                                            React.createElement(Elements.StandardButton, { onClick: () => {
                                                    dispatch(system_type_validation_state_1.Action.SystemTypeValidationCheckDefaultLanguages());
                                                } }, "Default"),
                                            React.createElement("table", null, availableLanguages.map(al => {
                                                const tablestate = state.settings.languagesToValidate.find(l => l === al);
                                                const checked = tablestate !== undefined;
                                                return (React.createElement("tr", { key: al },
                                                    React.createElement("td", null,
                                                        React.createElement("label", null,
                                                            React.createElement("input", { type: "checkbox", checked: checked, onChange: () => {
                                                                    dispatch(system_type_validation_state_1.Action.SystemTypeValidationToggleSelectedLanguages(al));
                                                                } }))),
                                                    React.createElement("td", null, al)));
                                            })))))))),
                            React.createElement(Elements.StandardButton, { disabled: state.settings.systemTypeId === undefined ||
                                    state.settings.systemTypeId === pleaseSelect, onClick: async () => {
                                    dispatch(system_type_validation_state_1.Action.SystemTypeValidationSetValidationProgress(true, "Initialize", 0, 0));
                                    dispatch(system_type_validation_state_1.Action.SystemTypeValidationSetResult([]));
                                    let numberOfSteps = 1;
                                    if (state.settings.validateRangeFilters) {
                                        numberOfSteps++;
                                    }
                                    if (state.settings.validateSysAndNewFilters) {
                                        numberOfSteps++;
                                    }
                                    if (state.settings.validateTemplates) {
                                        numberOfSteps++;
                                    }
                                    if (state.settings.validateEnergy) {
                                        numberOfSteps++;
                                    }
                                    if (state.settings.validateValueSourceUsage) {
                                        numberOfSteps++;
                                    }
                                    if (state.settings.validateCalculationMappings) {
                                        numberOfSteps++;
                                    }
                                    if (state.settings.validateCircularReferences) {
                                        numberOfSteps++;
                                    }
                                    if (state.settings.validateCostTables) {
                                        numberOfSteps++;
                                    }
                                    if (state.settings.validateProperties) {
                                        numberOfSteps++;
                                    }
                                    if (state.settings.validatePropertyTexts) {
                                        numberOfSteps++;
                                    }
                                    const messages = [];
                                    let current = 1;
                                    dispatch(system_type_validation_state_1.Action.SystemTypeValidationSetValidationProgress(true, "Pre validation", current, numberOfSteps));
                                    const preValidationResult = await getPreValidationResult(state.settings.systemTypeId, state.settings.skipRetired, state.settings.errorsOnly, config.graphqlEndpoint, config.authorization);
                                    messages.push(...preValidationResult.product
                                        .getSystemTypePreValidationResult.errors);
                                    if (!preValidationResult.product
                                        .getSystemTypePreValidationResult.ok) {
                                        dispatch(system_type_validation_state_1.Action.SystemTypeValidationSetResult(messages));
                                        dispatch(system_type_validation_state_1.Action.SystemTypeValidationSetValidationProgress(false, "", 0, 0));
                                        dispatch(system_type_validation_state_1.Action.SystemTypeValidationHideFilter());
                                        return;
                                    }
                                    if (state.settings.validateRangeFilters) {
                                        current++;
                                        dispatch(system_type_validation_state_1.Action.SystemTypeValidationSetValidationProgress(true, "Validate range filters", current, numberOfSteps));
                                        const rangeFilterResult = await getRangeFilterErrors(state.settings.systemTypeId, state.settings.skipRetired, state.settings.errorsOnly, config.graphqlEndpoint, config.authorization);
                                        messages.push(...rangeFilterResult.product
                                            .getSystemTypeRangeFilterErrors);
                                    }
                                    if (state.settings.validateSysAndNewFilters) {
                                        current++;
                                        dispatch(system_type_validation_state_1.Action.SystemTypeValidationSetValidationProgress(true, "Validate SYS- and NEW-filters", current, numberOfSteps));
                                        const sysAndNewFilterResult = await getSysAndNewFilterErrors(state.settings.systemTypeId, state.settings.skipRetired, state.settings.errorsOnly, config.graphqlEndpoint, config.authorization);
                                        messages.push(...sysAndNewFilterResult.product
                                            .getSystemTypeSysAndNewFilterErrors);
                                    }
                                    if (state.settings.validateTemplates) {
                                        current++;
                                        dispatch(system_type_validation_state_1.Action.SystemTypeValidationSetValidationProgress(true, "Validate Templates", current, numberOfSteps));
                                        const templateErrorsResult = await getTemplateErrors(state.settings.systemTypeId, state.settings.skipRetired, state.settings.errorsOnly, config.graphqlEndpoint, config.authorization);
                                        messages.push(...templateErrorsResult.product
                                            .getSystemTypeTemplateErrors);
                                    }
                                    if (state.settings.validateEnergy) {
                                        current++;
                                        dispatch(system_type_validation_state_1.Action.SystemTypeValidationSetValidationProgress(true, "Validate Energy", current, numberOfSteps));
                                        const energyErrorsResult = await getEnergyErrors(state.settings.systemTypeId, state.settings.skipRetired, state.settings.errorsOnly, config.graphqlEndpoint, config.authorization);
                                        messages.push(...energyErrorsResult.product
                                            .getSystemTypeEnergyErrors);
                                    }
                                    if (state.settings.validateValueSourceUsage) {
                                        current++;
                                        dispatch(system_type_validation_state_1.Action.SystemTypeValidationSetValidationProgress(true, "Validate value source usage", current, numberOfSteps));
                                        const valueSourceUsageErrors = await getValueSourceUsageErrors(state.settings.systemTypeId, state.settings.skipRetired, state.settings.errorsOnly, config.graphqlEndpoint, config.authorization);
                                        messages.push(...valueSourceUsageErrors.product
                                            .getSystemTypeValueSourceUsageErrors);
                                    }
                                    if (state.settings.validateCalculationMappings) {
                                        current++;
                                        dispatch(system_type_validation_state_1.Action.SystemTypeValidationSetValidationProgress(true, "Validate calculation mappings", current, numberOfSteps));
                                        const calculationMappingErrors = await getCalculationMappingErrors(state.settings.systemTypeId, state.settings.skipRetired, state.settings.errorsOnly, config.graphqlEndpoint, config.authorization);
                                        messages.push(...calculationMappingErrors.product
                                            .getSystemTypeCalculationMappingErrors);
                                    }
                                    if (state.settings.validateCircularReferences) {
                                        current++;
                                        dispatch(system_type_validation_state_1.Action.SystemTypeValidationSetValidationProgress(true, "Validate circular references", current, numberOfSteps));
                                        const circularReferencesErrors = await getCircularReferencesErrors(state.settings.systemTypeId, state.settings.skipRetired, state.settings.errorsOnly, config.graphqlEndpoint, config.authorization);
                                        messages.push(...circularReferencesErrors.product
                                            .getSystemTypeCircularReferencesErrors);
                                    }
                                    if (state.settings.validateCostTables) {
                                        current++;
                                        dispatch(system_type_validation_state_1.Action.SystemTypeValidationSetValidationProgress(true, "Validate cost tables", current, numberOfSteps));
                                        const costTablesErrors = await getCostTablesErrors(state.settings.systemTypeId, state.settings.skipRetired, state.settings.errorsOnly, config.graphqlEndpoint, config.authorization);
                                        messages.push(...costTablesErrors.product
                                            .getSystemTypeCostTablesErrors);
                                    }
                                    if (state.settings.validateProperties) {
                                        current++;
                                        dispatch(system_type_validation_state_1.Action.SystemTypeValidationSetValidationProgress(true, "Validate Properties", current, numberOfSteps));
                                        const productPropertyIssues = await getProductPropertyIssues(state.settings.systemTypeId, state.settings.skipRetired, state.settings.errorsOnly, config.graphqlEndpoint, config.authorization);
                                        messages.push(...productPropertyIssues.product
                                            .getSystemTypeProductPropertyIssues);
                                    }
                                    if (state.settings.validatePropertyTexts) {
                                        current++;
                                        dispatch(system_type_validation_state_1.Action.SystemTypeValidationSetValidationProgress(true, "Validate Property/PropertyValue texts", current, numberOfSteps));
                                        const productPropertyTextIssues = await getProductPropertyTextIssues(state.settings.systemTypeId, state.settings.languagesToValidate, state.settings.skipRetired, state.settings.errorsOnly, config.graphqlEndpoint, config.authorization);
                                        messages.push(...productPropertyTextIssues.product
                                            .getSystemTypeProductPropertyTextIssues
                                            .errorReport);
                                        dispatch(system_type_validation_state_1.Action.SetTextIssues(productPropertyTextIssues.product
                                            .getSystemTypeProductPropertyTextIssues
                                            .issues));
                                    }
                                    dispatch(system_type_validation_state_1.Action.SystemTypeValidationSetResult(messages));
                                    dispatch(system_type_validation_state_1.Action.SystemTypeValidationSetValidationProgress(false, "", 0, 0));
                                    dispatch(system_type_validation_state_1.Action.SystemTypeValidationHideFilter());
                                } }, "Validate"),
                            React.createElement("label", null,
                                "\u00A0Show only errors",
                                React.createElement("input", { type: "checkbox", checked: state.settings.errorsOnly, onChange: () => {
                                        dispatch(system_type_validation_state_1.Action.SystemTypeValidationSetSettings(Object.assign(Object.assign({}, state.settings), { errorsOnly: !state.settings.errorsOnly })));
                                    } })),
                            React.createElement("label", null,
                                "\u00A0Skip retired products",
                                React.createElement("input", { type: "checkbox", checked: state.settings.skipRetired, onChange: () => {
                                        dispatch(system_type_validation_state_1.Action.SystemTypeValidationSetSettings(Object.assign(Object.assign({}, state.settings), { skipRetired: !state.settings.skipRetired })));
                                    } }))))),
                    React.createElement(ResultContainer, null,
                        React.createElement(Exporter.XlsxSingleSheetExport, { data: getDataAsTable(state.messages), filename: state.settings.systemTypeId +
                                " - System type validation results" }, onClick => (React.createElement(Elements.StandardButton, { disabled: state.messages.length === 0, onClick: onClick }, "Export"))),
                        React.createElement(export_text_issues_1.ExportTextIssues, { data: state.issues, disabled: state.messages.length === 0, fileName: `${state.settings.systemTypeId}-text-issues` }),
                        state.messages.length > 1000 ? (React.createElement(React.Fragment, null,
                            " ",
                            "Displaying only 1000 rows. Use excel export for the rest.")) : (React.createElement(React.Fragment, null)),
                        React.createElement("textarea", { readOnly: true, value: state.messages
                                .slice(0, Math.min(1000, state.messages.length))
                                .join("\n") }))))));
    }))));
}
function getDataAsTable(messages) {
    return messages.map(v => {
        const row = [];
        row.push(v);
        return row;
    });
}
function getPreValidationResult(systemTypeId, skipRetired, errorsOnly, graphqlEndpoint, authorization) {
    return GraphQLRequest.request(getSystemTypePreValidationResultQuery, {
        input: {
            systemTypeId: systemTypeId,
            skipRetired: skipRetired,
            errorsOnly: errorsOnly
        }
    }, true, graphqlEndpoint, authorization);
}
function getRangeFilterErrors(systemTypeId, skipRetired, errorsOnly, graphqlEndpoint, authorization) {
    return GraphQLRequest.request(getRangeFilterErrorsQuery, {
        input: {
            systemTypeId: systemTypeId,
            skipRetired: skipRetired,
            errorsOnly: errorsOnly
        }
    }, true, graphqlEndpoint, authorization);
}
function getSysAndNewFilterErrors(systemTypeId, skipRetired, errorsOnly, graphqlEndpoint, authorization) {
    return GraphQLRequest.request(getSysAndNewFilterErrorsQuery, {
        input: {
            systemTypeId: systemTypeId,
            skipRetired: skipRetired,
            errorsOnly: errorsOnly
        }
    }, true, graphqlEndpoint, authorization);
}
function getTemplateErrors(systemTypeId, skipRetired, errorsOnly, graphqlEndpoint, authorization) {
    return GraphQLRequest.request(getTemplateErrorsQuery, {
        input: {
            systemTypeId: systemTypeId,
            skipRetired: skipRetired,
            errorsOnly: errorsOnly
        }
    }, true, graphqlEndpoint, authorization);
}
function getEnergyErrors(systemTypeId, skipRetired, errorsOnly, graphqlEndpoint, authorization) {
    return GraphQLRequest.request(getEnergyErrorsQuery, {
        input: {
            systemTypeId: systemTypeId,
            skipRetired: skipRetired,
            errorsOnly: errorsOnly
        }
    }, true, graphqlEndpoint, authorization);
}
function getValueSourceUsageErrors(systemTypeId, skipRetired, errorsOnly, graphqlEndpoint, authorization) {
    return GraphQLRequest.request(getValueSourceUsageErrorsQuery, {
        input: {
            systemTypeId: systemTypeId,
            skipRetired: skipRetired,
            errorsOnly: errorsOnly
        }
    }, true, graphqlEndpoint, authorization);
}
function getCalculationMappingErrors(systemTypeId, skipRetired, errorsOnly, graphqlEndpoint, authorization) {
    return GraphQLRequest.request(getCalculationMappingsErrorsQuery, {
        input: {
            systemTypeId: systemTypeId,
            skipRetired: skipRetired,
            errorsOnly: errorsOnly
        }
    }, true, graphqlEndpoint, authorization);
}
function getCircularReferencesErrors(systemTypeId, skipRetired, errorsOnly, graphqlEndpoint, authorization) {
    return GraphQLRequest.request(getCircularReferencesErrorsQuery, {
        input: {
            systemTypeId: systemTypeId,
            skipRetired: skipRetired,
            errorsOnly: errorsOnly
        }
    }, true, graphqlEndpoint, authorization);
}
function getCostTablesErrors(systemTypeId, skipRetired, errorsOnly, graphqlEndpoint, authorization) {
    return GraphQLRequest.request(getCostTablesErrorsQuery, {
        input: {
            systemTypeId: systemTypeId,
            skipRetired: skipRetired,
            errorsOnly: errorsOnly
        }
    }, true, graphqlEndpoint, authorization);
}
function getProductPropertyIssues(systemTypeId, skipRetired, errorsOnly, graphqlEndpoint, authorization) {
    return GraphQLRequest.request(getProductPropertyIssuesQuery, {
        input: {
            systemTypeId: systemTypeId,
            skipRetired: skipRetired,
            errorsOnly: errorsOnly
        }
    }, true, graphqlEndpoint, authorization);
}
function getProductPropertyTextIssues(systemTypeId, languages, skipRetired, errorsOnly, graphqlEndpoint, authorization) {
    return GraphQLRequest.request(getProductPropertyTextIssuesQuery, {
        input: {
            systemTypeId: systemTypeId,
            languages: languages,
            skipRetired: skipRetired,
            errorsOnly: errorsOnly
        }
    }, true, graphqlEndpoint, authorization);
}
exports.View = ReactRedux.connect((state) => ({ state: state.ui.systemTypeValidation }))(view);
//# sourceMappingURL=system-type-validation-view.js.map